type SubTitleProps = {
  title: string
  className?: string
}
export default function SubTitle({ title, className }: SubTitleProps): JSX.Element {
  return <p className={`text-[var(--text-landing-subtitle)] text-base ${className}`}>{title}</p>
}
